export default __webpack_public_path__ + "static/media/footerlogo.0496ca0b.png";